export default function getErrorMessage(err, defaultMsg) {
    var message = defaultMsg || 'An unexpected error occurred';
    if (err && err.data) {
        if (err.data.Message) {
            message = err.data.Message;
        } 
        else if (err.data.errors) {
            message = err.data.errors;
        }
    } else if (err.message) {
        message = err.message;
    }
    return message;
}